<template>
  <vs-popup
    class="vs-con-loading__container user-edit-popup"
    id="popup"
    title="DOWNLOAD RAW MATERIAL CONSUMPTION REPORT"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form
          @submit.prevent="handleSubmit(downloadReportDocument)"
          autocomplete="off"
        >
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="from"
                name="from"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">From</small>
                <flat-pickr
                  style="display: none"
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y' }"
                  v-model="from_date"
                  placeholder="Choose Date"
                />
                <flat-pickr
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y' }"
                  v-model="from_date"
                  placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="to"
                name="to"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">To</small>
                <flat-pickr
                  style="display: none"
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y' }"
                  v-model="to_date"
                  placeholder="Choose Date"
                />
                <flat-pickr
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y' }"
                  v-model="to_date"
                  placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="supplier-id"
                name="supplier-id"
                rules=""
                v-slot="{ errors }"
              >
                <small class="label">Suppliers</small>
                <v-select
                  :clearable="true"
                  placeholder="Suppliers"
                  v-model="selectedSuppliers"
                  :options="suppliers"
                  label="name"
                  :reduce="(option) => option.value"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                ></v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="raw-material-id"
                name="raw-material-id"
                rules=""
                v-slot="{ errors }"
              >
                <small class="label">Raw Materials</small>
                <v-select
                  :clearable="true"
                  placeholder="Raw Materials"
                  v-model="selectedRawMaterials"
                  :options="rawMaterials"
                  label="name"
                  :reduce="(option) => option.value"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                ></v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Download</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const ReportingRepository = RepositoryFactory.get("reporting");
const SupplierRawMaterialRepository = RepositoryFactory.get("supplierRawMaterial");
import "flatpickr/dist/plugins/monthSelect/style.css";
import vSelect from "vue-select";
import Utils from "@/mixins/Utils";

export default {
  data() {
    return {
      open: false,
      endPoint: "",
      date: "",
      to_date: "",
      from_date: "",
      rawMaterials: [],
      suppliers: [],
      selectedSuppliers: "",
      selectedRawMaterials: "",
    };
  },
  mixins: [Utils],
  components: {
    flatPickr,
    "v-select": vSelect,
  },
  mounted() {},
  watch: {
    selectedSuppliers: {
      async handler(newVal) {
        await this.onSupplierChange(newVal);
      }
    }
  },
  methods: {
    async onSupplierChange(val) {
      var supplierIdsStr = "";
      if (Array.isArray(val)) {
        supplierIdsStr = val.filter(function (id) { return id !== null && id !== undefined && id !== ""; }).join(",");
      } else if (val) {
        supplierIdsStr = String(val);
      }

      if (supplierIdsStr) {
        try {
          const res = (await SupplierRawMaterialRepository.getRawMaterialAcceptedList(1, "filter[supplier_ids]=" + supplierIdsStr, 150, "", 0)).data;
          const data = Array.isArray(res) ? res : (res.data || []);
          this.rawMaterials = data.map(function (x) {
            return {
              name: ((x.category && x.category.prefix) || "") + "-" + x.company_product_code,
              value: x.id
            };
          });
          if (this.selectedRawMaterials) {
            const validIds = this.rawMaterials.map(function (r) { return r.value; });
            if (validIds.indexOf(this.selectedRawMaterials) === -1) {
              this.selectedRawMaterials = "";
            }
          }
        } catch (e) {
          this.rawMaterials = this.$store.getters.raw_materials;
        }
      } else {
        this.rawMaterials = this.$store.getters.raw_materials;
      }
    },

    async openPopup(end_point, from, to, filters) {
      this.endPoint = "consumption-report/raw-material";
      this.suppliers = this.$store.getters.suppliers;
      this.rawMaterials = this.$store.getters.raw_materials;
      this.open = true;
      if (from && to) {
        this.from_date = from;
        this.to_date = to;
      }
      if (filters) {
        if (filters["supplier-id"]) {
          const sVal = filters["supplier-id"];
          this.selectedSuppliers = Array.isArray(sVal) ? (sVal.length > 0 ? sVal[0] : "") : sVal;
        }
        if (filters["raw-material-id"]) {
          const rmVal = filters["raw-material-id"];
          this.selectedRawMaterials = Array.isArray(rmVal) ? (rmVal.length > 0 ? rmVal[0] : "") : rmVal;
        }
      }
    },

    async downloadReportDocument() {
      this.$vs.loading();
      try {
        const response = await ReportingRepository.downloadSalesReportDocument(
          this.endPoint,
          `from=${this.from_date}&to=${this.to_date}&supplier-id=${this.selectedSuppliers}&raw-material-id=${this.selectedRawMaterials}`
        );
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `Raw Material Consumption Report (${this.from_date} - ${this.to_date}).xlsx`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
        this.open = false;
      } catch (e) {}
      this.$vs.loading.close();
    },
  },
};
</script>
